export default "__VITE_ASSET__b39a0d48__"